import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function FooterSection() {
  const quickLinks = categories.slice(0, 7);
  const moreLinks = categories.slice(7);

  return (
    <footer className="bg-foreground-950 text-white">
      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
          {/* Brand column */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <span className="font-heading text-2xl font-bold text-white tracking-tight">
                PandaBuy<span className="text-primary-400">Spreadsheet</span>
              </span>
            </Link>
            <p className="text-sm text-foreground-300 leading-relaxed mb-4 max-w-xs">
              Your trusted source for structured product comparison data and smart shopping insights.
            </p>
            <div className="flex items-center gap-3">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-9 h-9 rounded-full bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer" aria-label="Main website">
                <i className="ri-external-link-line text-sm"></i>
              </a>
            </div>
          </div>

          {/* Quick category links */}
          <div>
            <h4 className="font-heading text-base font-bold text-white mb-4">Categories</h4>
            <div className="w-8 h-px bg-primary-500 mb-4"></div>
            <ul className="space-y-2.5">
              {quickLinks.map((cat) => (
                <li key={cat.slug}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* More category links */}
          <div>
            <h4 className="font-heading text-base font-bold text-white mb-4">More Categories</h4>
            <div className="w-8 h-px bg-primary-500 mb-4"></div>
            <ul className="space-y-2.5">
              {moreLinks.map((cat) => (
                <li key={cat.slug}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Internal links */}
          <div>
            <h4 className="font-heading text-base font-bold text-white mb-4">Resources</h4>
            <div className="w-8 h-px bg-primary-500 mb-4"></div>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/blog/pandabuy-spreadsheet-comparison-guide" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">
                  Comparison Guide
                </Link>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">
                  Pandabuy Sheet
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">
                  Buy It Now
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-foreground-800">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} PandabuySpreadsheet. All rights reserved. This is an informational comparison website.
          </p>
          <p className="text-xs text-foreground-500">
            pandabuyspreadsheet &middot; product comparison spreadsheet &middot; smart shopping
          </p>
        </div>
      </div>
    </footer>
  );
}